const { typePolicies } = require('@shared-ui/apollo-type-policies');

// This is used in the .bernierc config file
module.exports = {
  ...typePolicies,
};